import { kuferClient, PROJECT_HEADER } from '@xver/libs/axios';

import {
    ContainerResponse,
    CreateContainerRequest,
    CreateContainerResponse,
    GetContainerLogsQueryModel,
    GetContainerLogsResponse,
    GetContainerResponse,
    GetDeletionTimestampResponse,
    GetMetricsQueryModel,
    GetMetricsResponse,
    ListContainerResponse,
    ListContainersQueryModel,
    LogTicketResponse,
    RedeployContainerResponse,
    RestartContainerResponse,
    ServiceStatus,
    UpdateContainerRequest,
    UpdateContainerResponse,
} from './model';

const ENDPOINTS = {
    LIST: '/v1/containers',
    CREATE: '/v1/containers',
    GET: (id: string) => `/v1/containers/${id}`,
    GET_STATUS: (id: string) => `/v1/containers/${id}/status`,
    UPDATE: (id: string) => `/v1/containers/${id}`,
    DELETE: (id: string) => `/v1/containers/${id}`,
    RESTART: (id: string) => `/v1/containers/${id}/restart`,
    REDEPLOY: (id: string) => `/v1/containers/${id}/redeploy`,
    LOGS: (id: string) => `/v1/containers/${id}/logs`,
    LOG_TICKET: (id: string) => `/v1/containers/${id}/logs/ticket`,
    METRICS: (id: string) => `/v1/containers/${id}/metrics`,
    DELETION_TIMESTAMP: (id: string) => `/v1/containers/${id}/deletion-timestamp`,
};

export function listContainers(params?: ListContainersQueryModel): Promise<ListContainerResponse> {
    return kuferClient.get(ENDPOINTS.LIST, { params });
}

export function createContainer(data: CreateContainerRequest): Promise<CreateContainerResponse> {
    return kuferClient.post(ENDPOINTS.CREATE, data);
}

/** `projectId` looks the container up in that project instead of the active one. */
export function getContainer(
    id: string,
    projectId?: string
): Promise<ContainerResponse | GetContainerResponse> {
    return kuferClient.get(
        ENDPOINTS.GET(id),
        projectId ? { headers: { [PROJECT_HEADER]: projectId } } : undefined
    );
}

export function getContainerStatus(id: string): Promise<ServiceStatus> {
    return kuferClient.get(ENDPOINTS.GET_STATUS(id));
}

export function updateContainer(
    id: string,
    data: UpdateContainerRequest
): Promise<UpdateContainerResponse> {
    return kuferClient.patch(ENDPOINTS.UPDATE(id), data);
}

export function deleteContainer(id: string): Promise<void> {
    return kuferClient.delete(ENDPOINTS.DELETE(id));
}

export function restartContainer(id: string): Promise<RestartContainerResponse> {
    return kuferClient.post(ENDPOINTS.RESTART(id));
}

export function redeployContainer(id: string): Promise<RedeployContainerResponse> {
    return kuferClient.post(ENDPOINTS.REDEPLOY(id));
}

export function getContainerLogs(
    id: string,
    params?: GetContainerLogsQueryModel
): Promise<GetContainerLogsResponse> {
    return kuferClient.get(ENDPOINTS.LOGS(id), { params });
}

export function requestContainerLogTicket(id: string): Promise<LogTicketResponse> {
    return kuferClient.post(ENDPOINTS.LOG_TICKET(id));
}

export function getContainerMetrics(
    id: string,
    params?: GetMetricsQueryModel
): Promise<GetMetricsResponse> {
    return kuferClient.get(ENDPOINTS.METRICS(id), { params });
}

export function getContainerDeletionTimestamp(id: string): Promise<GetDeletionTimestampResponse> {
    return kuferClient.get(ENDPOINTS.DELETION_TIMESTAMP(id));
}
